import { useCalcFormStore } from "@/stores/calcFormStore";
import { useUserStore } from "@/stores/userStore";

export function useCreatePaymentLink(amount = 0) {
    const calcFormStore = useCalcFormStore();
    const userStore = useUserStore();

    // Получаем telegram_id из userStore
    const telegramId = userStore.user?.telegram_id;

    if (!telegramId) {
        console.error("Telegram ID is not available.");
        // Можно показать сообщение пользователю или предпринять другие действия
        // return;
    }

    const payload = {
        amount: amount || Math.floor(calcFormStore.balanceWithCommission),
        steamUsername: calcFormStore.steamUsername,
        transactionId: calcFormStore.transactionId,
        promocode: calcFormStore.promocode,
        paymentType: calcFormStore.paymentType,
        telegramId: telegramId,
    };
    
    // transactionId не должен использоваться дважды
    calcFormStore.transactionId = '';
    calcFormStore.paymentLink = '';

    return calcFormStore.createPaymentLink(payload)
}